import React, { useRef, useEffect, useState } from "react";

import "./enter.styles.scss";
import { useScrollY } from "../../hooks/use-scroll-y";

type EnterProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
  enterStyle?: string;
  duration?: string;
};

const Enter: React.FC<EnterProps> = ({
  children,
  enterStyle,
  duration,
  ...otherProps
}) => {
  const [show, setShow] = useState(false);
  const enter = useRef<HTMLDivElement>(null);
  const scrollY = useScrollY();

  useEffect(() => {
    if (!enter.current) return;
    const { top } = enter.current.getBoundingClientRect();
    setShow(top < window.innerHeight);
  }, [scrollY]);

  const style = enterStyle || "fade";

  return (
    <div
      className={`enter ${show ? style : ""}`}
      ref={enter}
      style={{
        animationDuration: duration,
      }}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export default Enter;
